import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronDownSmall"><Path d="M8 10L12 14L16 10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronDownSmall;
